module.exports = __webpack_public_path__ + "static/img/comtop-five.285d605.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/comtop-five.png
// module id = ljk4
// module chunks = 0